import React from 'react';
import PropTypes from 'prop-types';
import { StyledPillText } from './styles';

export const PillText = ({
  text,
  variant = 'light',
  size = 'large',
  wiggle = false,
  wiggleDelay = 10,
}) => (
  <StyledPillText
    variant={variant}
    size={size}
    $wiggle={wiggle}
    $wiggleDelay={wiggleDelay}
  >
    {text}
  </StyledPillText>
);

PillText.displayName = 'PillText';
PillText.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['light', 'dark', 'lilac', 'yellow', 'warning']),
  size: PropTypes.oneOf(['small', 'large']),
  wiggle: PropTypes.bool,
  wiggleDelay: PropTypes.number,
};
